import { PropsWithChildren } from "react"
import { Stack } from "@mui/material"
import CheckBoxGroupCheckBox from "./check-box-group-check-box"
import { CheckBoxProps } from "@/components/inputs"

export default function ListCheckBoxGroup({
    children,
    ...props
}: CheckBoxProps & PropsWithChildren) {
    return <Stack>
        <CheckBoxGroupCheckBox {...props} />
        <Stack paddingLeft={"42px"}>
            {children}
        </Stack>
    </Stack>
}